<template>
  <ul class="list-buildings" v-if="poiList.length > 0" role="menu" aria-label="POI list">
    <poi-block v-for="poi in poiList" :key="poi.id" :poi="poi" :editMode="editMode"/>
  </ul>
  <ul class="list-buildings" v-else role="presentation">
    <li class="build error">
      <p>{{ $t("message.nothingError") }}</p>
    </li>
  </ul>
</template>

<script>
import PoiBlock from './PoiBlock'

export default {
  name: 'PoiList',
  components: {
    PoiBlock
  },
  props: {
    poiList: {
      type: Array,
      default: () => []
    },
    editMode: {
      type: Boolean,
      default: false
    }
  }
}
</script>
